import React, { Component } from "react";
import PropTypes from "prop-types";

import "leaflet/dist/leaflet.css";
import "bulma/css/bulma.css";
import "../css/styles.css";
import "../css/flex.css";
import "../css/form.css";
import "../css/filterbox.css";
import "../css/devices.css";
import "../css/welcome.css";
import "../css/privacy.css";

import NavigationBar from "./NavigationBar";
import ModalLoading from "./ModalLoading";

class App extends Component {
  VISIBILITY_DELAY = 2000;
  COOKIE_EXPIRY_THRESHOLD = 60 * 60 * 24 * 30; // 30 days

  state = {
    cookiesAccepted: true
  };

  loadUser = () => {
    !!this.props.token && this.props.onLoadUser();
  };

  componentDidUpdate(prevProps) {
    if (!!this.props.token && !prevProps.token) {
      this.loadUser();
    }
  }

  componentDidMount() {
    this.loadUser();
    setTimeout(() => {
      if (!this.isCookieAccepted()) {
        this.setState({ cookiesAccepted: false });
      }
    }, this.VISIBILITY_DELAY);
  }

  isCookieAccepted = () =>
    document.cookie.indexOf("kaDismissedCookieDisclaimer=true") >= 0;

  setPrivacyCookie = () => {
    document.cookie =
      "kaDismissedCookieDisclaimer=true; max-age=" +
      this.COOKIE_EXPIRY_THRESHOLD +
      ";path=/";
    this.setState({ cookiesAccepted: true });
  };

  renderCookiePanel = () => {
    return (
      <div className={`privacy ${this.state.cookiesAccepted && "hidden"}`}>
        <p>
          Für den Betrieb des Köln-Atlas verwenden wir Cookies. Wenn Sie den
          Köln-Atlas benutzen, stimmen Sie zu, dass Cookies auf Ihrem Rechner
          gespeichert und verwendet werden dürfen. Darüber hinaus erheben wir
          anonyme Daten, die zur Erhebung statistischer Daten dienen. Für
          Details beachten Sie bitte unsere{" "}
          <a href="/privacy" target="_blank">
            Datenschutzerklärung
          </a>
          .
        </p>
        <button className="is-success" onClick={this.setPrivacyCookie}>
          Ich bin einverstanden
        </button>
      </div>
    );
  };

  render() {
    const {
      isFixedHeight,
      appTitle,
      children,
      navIsOpen,
      isLoadingDistricts,
      isLoadingCategories,
      isLoadingUser,
      user,
      onToggleNav
    } = this.props;

    const isLoading =
      isLoadingUser || isLoadingDistricts || isLoadingCategories;

    return (
      <div
        className={`full-width ${
          isFixedHeight ? "full-height " : ""
        }flex-column flex-nowrap`}
      >
        <ModalLoading isActive={isLoading} />
        {this.renderCookiePanel()}

        <div className="flex-0-0 flex-row">
          <NavigationBar
            appTitle={appTitle}
            navIsOpen={navIsOpen}
            onToggleNav={onToggleNav}
            user={user}
          />
        </div>
        <div className="flex-1-1 flex-row">{children}</div>
      </div>
    );
  }
}

App.propTypes = {
  isFixedHeight: PropTypes.bool,
  appTitle: PropTypes.string,
  children: PropTypes.object,
  navIsOpen: PropTypes.bool,
  isLoadingDistricts: PropTypes.bool,
  user: PropTypes.object,
  activeInstitution: PropTypes.object,
  isLoadingCategories: PropTypes.bool,
  onToggleNav: PropTypes.func
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.jsx
 **/